import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertMessageComponent } from './alert-message.component';
import { CallCategoryPipeModule } from '@app/pipe/call-category.pipe';


@NgModule({
  declarations: [
    AlertMessageComponent,
  ],
  imports: [
    CommonModule,
    CallCategoryPipeModule
  ],
  exports: [
    AlertMessageComponent
  ]
})
export class AlertMessageModule { }
